import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    IconButton,
    List,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { girlBgImg } from "../../assets/images";


interface CancelAccountModalProps {
    open: boolean;
    onClose: () => void;
}

const CancelAccountModal: React.FC<CancelAccountModalProps> = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            className="cancel-account-dialog"
            sx={{
                "& .MuiDialog-paper": {
                    maxWidth: "1025px",
                    borderRadius: "24px",
                    position: "relative",
                    overflow: "auto",             
                },
            }}
        >
            <DialogTitle sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center", bgcolor: "#F6F6F6", gap: {xs:"24px" ,sm:"48px"}, }} padding={{ xs: "35px 24px", md: "37px 62px"}}>
                <img
                    src={girlBgImg} style={{ maxWidth: "32%" }} />
                <Box>
                    <Typography fontSize={{xs:"18px" ,sm:"24px"}} fontWeight="600" marginBottom="24px">
                        Canceling your subscription? Here’s what you’ll lose:                    
                    </Typography>
                    <List sx={{ display: "flex", mb: "14px", p: "0" }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{minWidth:"24px"}}>
                            <path d="M12.9988 9H10.9988V7H12.9988M12.9988 17H10.9988V11H12.9988M11.9988 2C10.6856 2 9.3852 2.25866 8.17194 2.7612C6.95869 3.26375 5.8563 4.00035 4.92771 4.92893C3.05235 6.8043 1.99878 9.34784 1.99878 12C1.99878 14.6522 3.05235 17.1957 4.92771 19.0711C5.8563 19.9997 6.95869 20.7362 8.17194 21.2388C9.3852 21.7413 10.6856 22 11.9988 22C14.6509 22 17.1945 20.9464 19.0698 19.0711C20.9452 17.1957 21.9988 14.6522 21.9988 12C21.9988 10.6868 21.7401 9.38642 21.2376 8.17317C20.735 6.95991 19.9984 5.85752 19.0698 4.92893C18.1413 4.00035 17.0389 3.26375 15.8256 2.7612C14.6124 2.25866 13.312 2 11.9988 2Z" fill="#E44258" />
                        </svg>
                        <Typography ml="12px" color="#4E4E4E" fontSize="16px">Your custom webinar settings</Typography>
                    </List>
                    <List sx={{ display: "flex", mb: "14px", p: "0" }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{minWidth:"24px"}}>
                            <path d="M12.9988 9H10.9988V7H12.9988M12.9988 17H10.9988V11H12.9988M11.9988 2C10.6856 2 9.3852 2.25866 8.17194 2.7612C6.95869 3.26375 5.8563 4.00035 4.92771 4.92893C3.05235 6.8043 1.99878 9.34784 1.99878 12C1.99878 14.6522 3.05235 17.1957 4.92771 19.0711C5.8563 19.9997 6.95869 20.7362 8.17194 21.2388C9.3852 21.7413 10.6856 22 11.9988 22C14.6509 22 17.1945 20.9464 19.0698 19.0711C20.9452 17.1957 21.9988 14.6522 21.9988 12C21.9988 10.6868 21.7401 9.38642 21.2376 8.17317C20.735 6.95991 19.9984 5.85752 19.0698 4.92893C18.1413 4.00035 17.0389 3.26375 15.8256 2.7612C14.6124 2.25866 13.312 2 11.9988 2Z" fill="#E44258" />
                        </svg>
                        <Typography ml="12px" color="#4E4E4E" fontSize="16px">All recorded webinar sessions linked to your account</Typography>
                    </List>
                    <List sx={{ display: "flex", mb: "14px", p: "0" }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{minWidth:"24px"}}>
                            <path d="M12.9988 9H10.9988V7H12.9988M12.9988 17H10.9988V11H12.9988M11.9988 2C10.6856 2 9.3852 2.25866 8.17194 2.7612C6.95869 3.26375 5.8563 4.00035 4.92771 4.92893C3.05235 6.8043 1.99878 9.34784 1.99878 12C1.99878 14.6522 3.05235 17.1957 4.92771 19.0711C5.8563 19.9997 6.95869 20.7362 8.17194 21.2388C9.3852 21.7413 10.6856 22 11.9988 22C14.6509 22 17.1945 20.9464 19.0698 19.0711C20.9452 17.1957 21.9988 14.6522 21.9988 12C21.9988 10.6868 21.7401 9.38642 21.2376 8.17317C20.735 6.95991 19.9984 5.85752 19.0698 4.92893C18.1413 4.00035 17.0389 3.26375 15.8256 2.7612C14.6124 2.25866 13.312 2 11.9988 2Z" fill="#E44258" />
                        </svg>
                        <Typography ml="12px" color="#4E4E4E" fontSize="16px">Data on past webinar registrants and their analytics</Typography>
                    </List>
                    <List sx={{ display: "flex", mb: "14px", p: "0" }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{minWidth:"24px"}}>
                            <path d="M12.9988 9H10.9988V7H12.9988M12.9988 17H10.9988V11H12.9988M11.9988 2C10.6856 2 9.3852 2.25866 8.17194 2.7612C6.95869 3.26375 5.8563 4.00035 4.92771 4.92893C3.05235 6.8043 1.99878 9.34784 1.99878 12C1.99878 14.6522 3.05235 17.1957 4.92771 19.0711C5.8563 19.9997 6.95869 20.7362 8.17194 21.2388C9.3852 21.7413 10.6856 22 11.9988 22C14.6509 22 17.1945 20.9464 19.0698 19.0711C20.9452 17.1957 21.9988 14.6522 21.9988 12C21.9988 10.6868 21.7401 9.38642 21.2376 8.17317C20.735 6.95991 19.9984 5.85752 19.0698 4.92893C18.1413 4.00035 17.0389 3.26375 15.8256 2.7612C14.6124 2.25866 13.312 2 11.9988 2Z" fill="#E44258" />
                        </svg>
                        <Typography ml="12px" color="#4E4E4E" fontSize="16px">Any CRM integrations from your subscription plan</Typography>
                    </List>
                </Box>

                <IconButton onClick={onClose} sx={{ position: "absolute", right: "12px", top: "15px" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ marginTop: {xs:"36px" ,sm:"64px"} , mb: "36px" ,overflow:"unset" ,px:"16px" ,pb:"0" }}>
                <Typography color="#2B2B30" fontSize={{xs:"18px" ,sm:"24px"}} maxWidth="665px" margin="auto" textAlign="center" fontWeight="600">We recommend you to pause your account so that you don’t lose your data and start again where you left.</Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", gap: 2, display: "flex", marginBottom: {xs:"20px" ,sm:"64px"}  ,flexWrap:"wrap"}}>
                <Button variant="contained" color="primary" sx={{ textTransform: "capitalize"  ,borderRadius:"8px" ,height:"48px"}}>Pause my account for $7.99/month</Button>
                <Button variant="text" color="error" sx={{ textTransform: "capitalize" ,height:"48px"}}>Thanks, but I want to cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelAccountModal;



